import React from 'react';
//import './App.css';
import CardsUpdate from './components/CardsUpdate';
import Footer  from './components/bodyParts/Footer.js';

function App() {
  return (
    <div >
     <CardsUpdate/>
     <Footer/>
    </div>
  );
}

export default App;
